module.exports = __webpack_public_path__ + "img/slow_logo.37d6cb5c.png";